<template>
  <div class="template-section-with-header">
    <header class="template-section-with-header-header">
      <slot name="header" />
    </header>
    <div class="template-section-with-header-main"><slot /></div>
  </div>
</template>
<script lang="ts" setup></script>
<style lang="scss" scoped>
.template-section-with-header {
  display: grid;
  grid-template-areas: 'content-header' 'content-main';
  grid-template-rows: auto 1fr;
  column-gap: var(--column_gap);
  row-gap: var(--row_gap);

  &-main {
    grid-area: content-main;
  }

  &-header {
    grid-area: content-header;
  }
}
</style>
